// Generated by scripts/build-spectral-tables.mjs — do not edit by hand.
// Grid: 360–830 nm in 5 nm steps (95 values).
//
// Ozone absorption cross-section at 223 K, m^2 per molecule, from the IUP Bremen broadband
// measurements: A. Serdyuchenko, V. Gorshelev, M. Weber, W. Chehade, J. P. Burrows (2014),
// "High spectral resolution ozone absorption cross-sections – Part 2: Temperature dependence",
// Atmos. Meas. Tech. 7, 625–636, doi:10.5194/amt-7-625-2014 (data: iup.uni-bremen.de, molspec).
// Each value is the box average over [λ − 2.5, λ + 2.5] nm of the 0.01 nm data.
export const OZONE_CROSS_SECTION_5NM: readonly number[] = [
  2.58e-27, 7.575e-28, 3.969e-28, 1.745e-28, 1.542e-28, 2.044e-28, 3.399e-28, 6.258e-28, 8.923e-28,
  1.279e-27, 2.263e-27, 2.565e-27, 3.459e-27, 6.129e-27, 6.244e-27, 8.057e-27, 1.304e-26, 1.565e-26,
  1.712e-26, 2.012e-26, 3.466e-26, 3.377e-26, 3.782e-26, 4.44e-26, 7.177e-26, 7.646e-26, 7.678e-26,
  8.582e-26, 1.161e-25, 1.541e-25, 1.501e-25, 1.589e-25, 1.764e-25, 2.116e-25, 2.577e-25, 2.765e-25,
  2.843e-25, 3.103e-25, 3.273e-25, 3.469e-25, 3.86e-25, 4.284e-25, 4.579e-25, 4.718e-25, 4.548e-25,
  4.373e-25, 4.383e-25, 4.692e-25, 5.075e-25, 5.069e-25, 4.701e-25, 4.29e-25, 3.981e-25, 3.744e-25,
  3.49e-25, 3.219e-25, 2.919e-25, 2.653e-25, 2.435e-25, 2.234e-25, 2.039e-25, 1.851e-25, 1.647e-25,
  1.464e-25, 1.315e-25, 1.211e-25, 1.074e-25, 9.353e-26, 8.165e-26, 7.38e-26, 6.869e-26, 6.612e-26,
  5.892e-26, 5.059e-26, 4.428e-26, 4.097e-26, 4.033e-26, 4.264e-26, 4.092e-26, 3.143e-26, 2.623e-26,
  2.409e-26, 2.392e-26, 2.788e-26, 3.106e-26, 2.491e-26, 1.93e-26, 1.573e-26, 1.404e-26, 1.394e-26,
  1.73e-26, 2.147e-26, 2.005e-26, 1.323e-26, 8.589e-27,
];
